"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const main_component_1 = require("./main.component");
const Routes = [
    {
        path: 'folder/:folderId', component: main_component_1.MainComponent,
    },
    {
        path: 'folder', component: main_component_1.MainComponent,
    }
];
class FileModule {
}
exports.FileModule = FileModule;
